import lazyScreen from '../utils/lazyScreen';
const EXPGeneralOrders = lazyScreen(() => import('../pages/exp/EXPGeneralOrders/index.js'), 'pages/exp/EXPGeneralOrders/index.js');
const EXPPurchaseOrders = lazyScreen(() => import('../pages/exp/EXPPurchaseOrders/index.js'), 'pages/exp/EXPPurchaseOrders/index.js');
const EXPPurchaseOrder = lazyScreen(() => import('../pages/exp/EXPPurchaseOrder/index.js'), 'pages/exp/EXPPurchaseOrder/index.js');
const EXPImportDutyOrders = lazyScreen(() => import('../pages/exp/EXPImportDutyOrders/index.js'), 'pages/exp/EXPImportDutyOrders/index.js');
const EXPImportDutyOrder = lazyScreen(() => import('../pages/exp/EXPImportDutyOrder/index.js'), 'pages/exp/EXPImportDutyOrder/index.js');
const EXPPayrollOrders = lazyScreen(() => import('../pages/exp/EXPPayrollOrders/index.js'), 'pages/exp/EXPPayrollOrders/index.js');
const EXPPayrollOrder = lazyScreen(() => import('../pages/exp/EXPPayrollOrder/index.js'), 'pages/exp/EXPPayrollOrder/index.js');
const EXPInsuranceOrders = lazyScreen(() => import('../pages/exp/EXPInsuranceOrders/index.js'), 'pages/exp/EXPInsuranceOrders/index.js');
const EXPInsuranceOrder = lazyScreen(() => import('../pages/exp/EXPInsuranceOrder/index.js'), 'pages/exp/EXPInsuranceOrder/index.js');
const EXPTaxOrders = lazyScreen(() => import('../pages/exp/EXPTaxOrders/index.js'), 'pages/exp/EXPTaxOrders/index.js');
const EXPTaxOrder = lazyScreen(() => import('../pages/exp/EXPTaxOrder/index.js'), 'pages/exp/EXPTaxOrder/index.js');
const EXPOrder = lazyScreen(() => import('../pages/exp/EXPOrder/index.js'), 'pages/exp/EXPOrder/index.js');
const EXPInvoices = lazyScreen(() => import('../pages/exp/EXPInvoices/index.js'), 'pages/exp/EXPInvoices/index.js');
const EXPInvoice = lazyScreen(() => import('../pages/exp/EXPInvoice/index.js'), 'pages/exp/EXPInvoice/index.js');
const EXPPayments = lazyScreen(() => import('../pages/exp/EXPPayments/index.js'), 'pages/exp/EXPPayments/index.js');
const EXPAllocatePM = lazyScreen(() => import('../pages/exp/EXPAllocatePM/index.js'), 'pages/exp/EXPAllocatePM/index.js');
const EXPAllocatePMs = lazyScreen(() => import('../pages/exp/EXPAllocatePMs/index.js'), 'pages/exp/EXPAllocatePMs/index.js');
const EXPAllocateAP = lazyScreen(() => import('../pages/exp/EXPAllocateAP/index.js'), 'pages/exp/EXPAllocateAP/index.js');
const EXPAllocateAPs = lazyScreen(() => import('../pages/exp/EXPAllocateAPs/index.js'), 'pages/exp/EXPAllocateAPs/index.js');
const EXPExtraPayableOrder = lazyScreen(() => import('../pages/exp/EXPExtraPayableOrder/index.js'), 'pages/exp/EXPExtraPayableOrder/index.js');
const EXPExtraPayableOrders = lazyScreen(() => import('../pages/exp/EXPExtraPayableOrders/index.js'), 'pages/exp/EXPExtraPayableOrders/index.js');
const EXPEquipmentProcurementOrder = lazyScreen(() => import('../pages/exp/EXPEquipmentProcurementOrder/index.js'), 'pages/exp/EXPEquipmentProcurementOrder/index.js');
const EXPEquipmentProcurementOrders = lazyScreen(() => import('../pages/exp/EXPEquipmentProcurementOrders/index.js'), 'pages/exp/EXPEquipmentProcurementOrders/index.js');
const EXPAssetProcurementOrder = lazyScreen(() => import('../pages/exp/EXPAssetProcurementOrder/index.js'), 'pages/exp/EXPAssetProcurementOrder/index.js');
const EXPAssetProcurementOrders = lazyScreen(() => import('../pages/exp/EXPAssetProcurementOrders/index.js'), 'pages/exp/EXPAssetProcurementOrders/index.js');
const EXPLogisticOrders = lazyScreen(() => import('../pages/exp/EXPLogisticOrders/index.js'), 'pages/exp/EXPLogisticOrders/index.js');
const EXPBudgets = lazyScreen(() => import('../pages/exp/EXPBudgets/index.js'), 'pages/exp/EXPBudgets/index.js');
const EXPBudget = lazyScreen(() => import('../pages/exp/EXPBudget/index.js'), 'pages/exp/EXPBudget/index.js');
const EXPBudgetComparisons = lazyScreen(() => import('../pages/exp/EXPBudgetComparisons/index.js'), 'pages/exp/EXPBudgetComparisons/index.js');

export default [
    {
        path: '/exp/EXPGeneralOrders',
        component: EXPGeneralOrders
    },
    {
        path: '/exp/EXPPurchaseOrders',
        component: EXPPurchaseOrders
    },
    {
        path: '/exp/EXPPurchaseOrder/:code',
        component: EXPPurchaseOrder
    },
    {
        path: '/exp/EXPImportDutyOrders',
        component: EXPImportDutyOrders
    },
    {
        path: '/exp/EXPImportDutyOrder/:code',
        component: EXPImportDutyOrder
    },
    {
        path: '/exp/EXPPayrollOrders',
        component: EXPPayrollOrders
    },
    {
        path: '/exp/EXPPayrollOrder/:code',
        component: EXPPayrollOrder
    },
    {
        path: '/exp/EXPInsuranceOrders',
        component: EXPInsuranceOrders
    },
    {
        path: '/exp/EXPInsuranceOrder/:code',
        component: EXPInsuranceOrder
    },
    {
        path: '/exp/EXPTaxOrders',
        component: EXPTaxOrders
    },
    {
        path: '/exp/EXPTaxOrder/:code',
        component: EXPTaxOrder
    },
    {
        path: '/exp/EXPLogisticOrders',
        component: EXPLogisticOrders
    },
    {
        path: '/exp/EXPOrder/:code',
        component: EXPOrder
    },
    {
        path: '/exp/EXPInvoices',
        component: EXPInvoices
    },
    {
        path: '/exp/EXPInvoice/:code',
        component: EXPInvoice
    },
    {
        path: '/exp/EXPPayments',
        component: EXPPayments
    },
    // {
    //     path: '/exp/EXPPayment/:code',
    //     component: EXPPayment
    // },
    // {
    //     path: '/exp/CAIssues',
    //     component: CAIssues
    // },
    // {
    //     path: '/exp/CAReceives',
    //     component: CAReceives
    // },
    {
        path: '/exp/EXPAllocatePMs',
        component: EXPAllocatePMs
    },
    {
        path: '/exp/EXPAllocatePM/:code',
        component: EXPAllocatePM
    },
    {
        path: '/exp/EXPAllocateAPs',
        component: EXPAllocateAPs
    },
    {
        path: '/exp/EXPAllocateAP/:code',
        component: EXPAllocateAP
    },
    {
        path: '/exp/EXPExtraPayableOrders',
        component: EXPExtraPayableOrders
    },
    {
        path: '/exp/EXPExtraPayableOrder/:code',
        component: EXPExtraPayableOrder
    },
    {
        path: '/exp/EXPAssetProcurementOrders',
        component: EXPAssetProcurementOrders
    },
    {
        path: '/exp/EXPAssetProcurementOrder/:code',
        component: EXPAssetProcurementOrder
    },
    {
        path: '/exp/EXPEquipmentProcurementOrders',
        component: EXPEquipmentProcurementOrders
    },
    {
        path: '/exp/EXPEquipmentProcurementOrder/:code',
        component: EXPEquipmentProcurementOrder
    },
    {
        path: '/exp/EXPBudgets',
        component: EXPBudgets
    },
    {
        path: '/exp/EXPBudget/:code',
        component: EXPBudget
    },
    {
        path: '/exp/EXPBudgetComparisons',
        component: EXPBudgetComparisons
    },
];
